export const NotebookConstants = {
    SharedPageNotebookId: 0,
};
